/* eslint-disable import/prefer-default-export */
export const LAUNCHPAD_HOST_NAME = 'partner.launchpad.ritual.co';
export const PROD_PP_URL = 'https://partner.ritual.co';
